export default __webpack_public_path__ + "static/media/Bain & Company.0a4868b7.png";